import styled from 'styled-components'

import { CurrencyIcon } from '@root/entities/currency/ui'

import { PremiumCurrencyInfoAddress } from './premium-currency-info-address'
import { PremiumCurrencyInfoHeading } from './premium-currency-info-heading'

import type { PremiumMetaModel } from '../../atoms'
import type { CurrencyModel } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel | undefined
} & ClassNameProps

export const PremiumCurrencyInfo: React.FC<Props> = ({
  currency,
  premium,
  className,
}) => {
  return (
    <Root className={className}>
      <Group>
        <CurrencyIcon
          key={currency.address}
          currency={currency}
          size={90}
          withNetwork
        />
        <PremiumCurrencyInfoHeading premiumInfo={premium} currency={currency} />
      </Group>
      <PremiumCurrencyInfoAddress currency={currency} mode="primary" />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 16px;

  width: 100%;
`

const Group = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  text-transform: uppercase;

  gap: 16px;
`
